<template>
  <div class="doumi-ctn">
    <Form>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">开启任务</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.allowPrivateMsg" />
          </div>
        </div>
      </div>
      <Field v-model="config.jobPeriod" type="number" placeholder="任务执行间隔时间" label="任务间隔(秒)"></Field>
      <Field type="textarea" v-model="config.commentKeywords" placeholder="评论关键词(,分隔)" label="评论关键词"></Field>
      <Field type="text" v-model="config.privateContent" placeholder="私信内容" label="私信内容"></Field>
      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">性别</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <van-checkbox-group v-model="config.genders" direction="horizontal" checked-color="#07c160">
              <van-checkbox :name="1" :model-value="1">男</van-checkbox>
              <van-checkbox :name="0" :model-value="0">女</van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
      </div>

      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">年龄范围</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <van-stepper theme="round" button-size="22" v-model="config.minAge" />&nbsp;至&nbsp;<van-stepper theme="round" button-size="22"  v-model="config.maxAge" />岁
          </div>
        </div>
      </div>

      <div class="van-cell van-field">
        <div class="van-cell__title van-field__label"><label id="van-field-28-label" for="van-field-28-input">自动关注</label><!----></div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body"><van-switch active-color="#07c160" inactive-color="#BABDC3" v-model="config.autoFollow" />
          </div>
        </div>
      </div>

      <div class="button-wrap">
        <Button type="primary" @click="doSaveConfig">保存</Button>
        <Button type="primary" @click="config.showQrCode=true">配置二维码</Button>
      </div>
    </Form>
    <van-overlay :show="config.showQrCode" @click="config.showQrCode = false">
      <div class="loading-wrapper">
        <div ref="alipayWap" style="text-align: left">
          <div style="display: flex;align-items: center;justify-content: center;"><vue-qrcode :value="config.configUrl"></vue-qrcode></div>
          <div style="display: flex;align-items: center;justify-content: center;margin-top: 1rem;"><Button type="primary" @click="config.showQrCode = false">关闭</Button></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<style lang="less">
@import "@/app.less";
.doumi-ctn{
  --van-stepper-button-round-theme-color: @color11;
  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }

  .form-tips{
    color: @color2;
    text-align: left;
    padding: 0 1rem 0 1rem;
  }
  .button-wrap {
    display: flex;
    justify-content: space-evenly;
  }
}

</style>

<script>
import {Button, Field, Form, showNotify} from "vant";
import store from "@/store";
import {onMounted, ref} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import API from "@/api";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import Clipbord from "@/components/Clipbord.vue";

export default {
  name: 'DoumiConfig',
  components: {Clipbord, VueQrcode, Form, Field, ClipbordComponent, Button},
  setup(){
    /**
     * {DoumiClientConfig}
     */
    const config = ref({
      allowPrivateMsg: false,
      commentKeywords: "",
      privateContent: "恭喜发财！",
      genders:[],
      minAge:'',
      maxAge:'',
      autoFollow: false
    });

    const userStore = store.userStore();

    const doumiStore = store.doumiStore();

    onMounted(async () => {
      const res = await doumiStore.getDoumiClientConfig(userStore.getDeviceId());
      if(res.success){
        config.value = res.data;
        if(!config.value.genders){
          config.value.genders = [];
        }
        config.value.configUrl="https://www.haoping.fun/doumi-config?deviceId=" + encodeURIComponent(userStore.getDeviceId());
      }
    });

    return {config};
  },
  methods: {
    async doSaveConfig() {
      const config = this.config;
      const params = Object.assign({}, config);
      const res = await API.doumi.doSetDoumiClientConfig({config:params, deviceId: store.userStore().getDeviceId()});
      if(res.success){
        showNotify({type:"success", message: "保存成功" });
      }else{
        showNotify({type:"warning", message: res.errorMsg});
      }
    }
  }
}
</script>
